import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import {
	CPCreqHistoryEnrollmentSharedLocNames,
	creqEnrollmentSharedLocs,
} from '../../models/enrollment.locs';

export type CPCReqHistoryEnrollmentLocNames =
	| 'CPCReqHistoryEnrollmentPageTitle'
	| 'CPCReqHistoryEnrollmentPageDescription'
	| 'CPCReqHistoryEnrollmentGroupNameLabel'
	| 'CPCReqHistoryEnrollmentNameLabel'
	| 'CPCReqHistoryEnrollmentActiveDateLabel'
	| 'CPCReqHistoryEnrollmentExpireDateLabel'
	| 'CPCReqHistoryEnrollmentButtonGoBack'
	| 'CPCReqHistoryEnrollmentButtonInfo'
	| 'CPCReqHistoryEnrollmentButtonViewMore'
	| 'CPCReqHistoryEnrollmentContentPageDescription'
	| CPCreqHistoryEnrollmentSharedLocNames;

export const creqEnrollmentLocs: LocDefs<CPCReqHistoryEnrollmentLocNames> = {
	// Page level
	CPCReqHistoryEnrollmentPageTitle: {
		defaultValue: 'Enrollment',
		description: 'Page title for: Enrollment.',
		displayPath: 'History|Enrollment|Page Title',
		portal: 'CP',
		displayType: 'Title',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.Title.PageTitle',
	},
	CPCReqHistoryEnrollmentPageDescription: {
		defaultValue: 'Enrollment',
		description: 'Page description for: Enrollment.',
		displayPath: 'History|Enrollment|Page Description',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: true,
		shared: false,
	},

	// Buttons
	CPCReqHistoryEnrollmentButtonGoBack: {
		defaultValue: 'Go Back',
		description: 'Button label for: Go Back.',
		displayPath: 'History|Enrollment|Go Back',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.Button.GoBack',
	},
	CPCReqHistoryEnrollmentButtonInfo: {
		defaultValue: 'Info',
		description: 'Button label for: Info.',
		displayPath: 'History|Enrollment|Info',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.Button.Info',
	},
	CPCReqHistoryEnrollmentButtonViewMore: {
		defaultValue: 'View More',
		description: 'Button label for: View More.',
		displayPath: 'History|Enrollment|View More',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.Button.ViewMore',
	},

	// Content
	...creqEnrollmentSharedLocs,
	CPCReqHistoryEnrollmentContentPageDescription: {
		defaultValue: 'Enrollment',
		description: 'Page description for: Enrollment.',
		displayPath: 'History|Enrollment|Page Description',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: true,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.Content.PageDescription',
	},

	// Original Field Labels
	CPCReqHistoryEnrollmentGroupNameLabel: {
		defaultValue: 'Group',
		description: 'Field label for: Group.',
		displayPath: 'History|Enrollment|Group',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.FieldLabel.GroupName',
	},
	CPCReqHistoryEnrollmentNameLabel: {
		defaultValue: 'Name',
		description: 'Field label for: Name.',
		displayPath: 'History|Enrollment|Name',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.FieldLabel.Name',
	},
	CPCReqHistoryEnrollmentActiveDateLabel: {
		defaultValue: 'Active Date',
		description: 'Field label for: Active Date.',
		displayPath: 'History|Enrollment|Active Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.FieldLabel.ActiveDate',
	},
	CPCReqHistoryEnrollmentExpireDateLabel: {
		defaultValue: 'Expire Date',
		description: 'Field label for: Expire Date.',
		displayPath: 'History|Enrollment|Expire Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.Enrollment.FieldLabel.ExpireDate',
	},
};

export const creqEnrollmentPageLocs: Pick<
	LocMap<CPCReqHistoryEnrollmentLocNames>,
	'CPCReqHistoryEnrollmentPageTitle' | 'CPCReqHistoryEnrollmentPageDescription'
> = {
	CPCReqHistoryEnrollmentPageTitle: 'CPCReqHistoryEnrollmentPageTitle',
	CPCReqHistoryEnrollmentPageDescription: 'CPCReqHistoryEnrollmentPageDescription',
};

export const cpCreqEnrollmentLocKeys =
	MapLocKeys<CPCReqHistoryEnrollmentLocNames>(creqEnrollmentLocs);
export type CPCreqHistoryEnrollmentLocKeys = typeof cpCreqEnrollmentLocKeys;
